import React from 'react'
import RaceColumn from './../RaceColumn/RaceColumn.component'

const LeaderRace = () => {
  return (
    <RaceColumn
      raceKey='leader'
      title="Division Leader's Race to the Royal Ring"
      subtitle='2.5MM Points (approx. $80MM AV) since 01/01/2021'
    />
  )
}

export default LeaderRace
